(function () {
    "use strict";

    angular.module("app").factory("FileUploaderFactory", FileUploaderFactoryFactory);

    FileUploaderFactoryFactory.$inject = ["FileUploader", "UPLOAD_MAX_SIZE", "base64Service"];
    function FileUploaderFactoryFactory(FileUploader, UPLOAD_MAX_SIZE, base64Service) {

        const fileSizeFilter = { name: "enforceMaxFileSize", fn: (item) => item.size <= UPLOAD_MAX_SIZE };
        const defaultFilters = [
            {
                name: "defaultExtensionFilter",
                fn: function (item) {
                    const ext = item.name.split(".").pop().toLowerCase();
                    return ext === "pdf";
                }
            },
            fileSizeFilter,
        ];

        const defaultSettings = {
            removeAfterUpload: true,
            queueLimit: 1,
        };

        return {
            CreateFileUploader: create,
            AddExtensionFilter: addExtensionFilter
        };

        function create(options, callbacks) {

            if (!options || !angular.isObject(options))
                options = {};

            const uploaderOptions = { ...defaultSettings, ...options };
            uploaderOptions.filters = [...defaultFilters];
            if (options.filters)
                uploaderOptions.push(...options.filter);

            const uploader = new FileUploader(uploaderOptions);

            // Override the upload function
            uploader.uploadItem = localUpload;

            uploader.onAfterAddingFile = fileItem => fileItem.upload();
            uploader.onSuccessItem = callbacks.onSuccessItem;
            uploader.onErrorItem = callbacks.onErrorItem;
            uploader.onCompleteAll = callbacks.onCompleteAll;

            return uploader;
        }

        function addExtensionFilter(uploader, extensions) {
            if (angular.isString(extensions))
                extensions = extensions.toLowerCase().replace(/\./g, '').split(",");

            if (!Array.isArray(extensions)) {
                extensions = ["pdf"];
            }
            else {
                extensions = extensions.map(ext => ext.toLowerCase());
            }

            // Remove default extension filter to avoid blocking explicitly allowed extensions
            const defaultExtensionFilterIndex = uploader.filters.findIndex(f => f.name === "defaultExtensionFilter");
            if (defaultExtensionFilterIndex > -1)
                uploader.filters.splice(defaultExtensionFilterIndex, 1);

            uploader.filters.push({
                name: "enforceFileExtension",
                fn: function (item) {
                    const ext = item.name.split(".").pop().toLowerCase();
                    return extensions.includes(ext);
                }
            });
        }

        function localUpload(fileItem) {

            const _this = fileItem.uploader;

            const index = _this.getIndexOfItem(fileItem);
            const item = _this.queue[index];

            item._prepareToUploading();
            if (_this.isUploading) return;

            _this._onBeforeUploadItem(item);
            if (item.isCancel) return;

            item.isUploading = true;
            _this.isUploading = true;

            readFile(fileItem);

            _this._render();
        }

        function readFile(fileItem) {
            const nativeFile = fileItem._file;
            const reader = new FileReader();

            reader.onprogress = function (_e) { };

            reader.onerror = function (_e) {
                fileItem.error = reader.error;
                fileItem.uploader._onErrorItem(fileItem, {}, null, null);
                fileItem.uploader._onCompleteItem(fileItem, {}, "Error", {});
            };

            reader.onload = function () {
                const content = base64Service.convertArrayBufferToBase64String(reader.result);
                const name = nativeFile.name;
                const attachment = { Name: name, Content: content, Uploaded: new Date(), FileSize: nativeFile.size };

                fileItem.uploader._onSuccessItem(fileItem, attachment, "Success", {});
                fileItem.uploader._onCompleteItem(fileItem, attachment, "Success", {});
            };
            reader.readAsArrayBuffer(nativeFile);
        }
    }
})();
